import {
  AdminOrganizationArchiveRequest,
  AdminActiveSession,
  AdminOrganizationCancelInvitationRequest,
  AdminOrganizationCreateRequest,
  AdminOrganizationDomainSettingsDetail,
  AdminOrganizationDomainSettingsGetRequest,
  AdminOrganizationDomainSettingsUpdateRequest,
  AdminOrganizationDetail,
  AdminOrganizationInternalsDetail,
  AdminOrganizationInternalsGetRequest,
  AdminOrganizationInternalsUpdateRequest,
  AdminOrganizationGetRequest,
  AdminOrganizationInviteUserRequest,
  AdminOrganizationListItem,
  AdminOrganizationListRequest,
  AdminOrganizationPermissions,
  AdminOrganizationRemoveUserRequest,
  AdminOrganizationResendInvitationRequest,
  AdminOrganizationSubscriptionDetail,
  AdminOrganizationSubscriptionGetRequest,
  AdminOrganizationSubscriptionUpdateRequest,
  AdminOrganizationUsageDetail,
  AdminOrganizationUpdateRequest,
  AdminOrganizationUpdateUserRoleRequest,
  AdminOrganizationUserItem,
  AdminOrganizationUsersListRequest,
  AdminConnectedDomainArchiveRequest,
  AdminConnectedDomainCreateRequest,
  AdminConnectedDomainDetail,
  AdminConnectedDomainGetRequest,
  AdminConnectedDomainMarkVerifiedRequest,
  AdminConnectedDomainVerificationDetail,
  AdminConnectedDomainsListRequest,
  AdminConnectedDomainVerifyRequest,
  AdminManagedDomainArchiveRequest,
  AdminManagedDomainAvailabilityDetail,
  AdminManagedDomainAvailabilityRequest,
  AdminManagedDomainCreateRequest,
  AdminManagedDomainDetail,
  AdminManagedDomainGetRequest,
  AdminManagedDomainsListRequest,
  AdminMutationResponse,
  AdminPage,
  AdminProfileDetail,
  AdminSystemInformationDetail,
  AdminProfileUpdateRequest,
  AdminSignArchiveRequest,
  AdminSignCreateRequest,
  AdminSignDetail,
  AdminSignGetRequest,
  AdminSignListItem,
  AdminSignListRequest,
  AdminSignUpdateRequest,
  AdminSiteArchiveRequest,
  AdminSiteCreateRequest,
  AdminSiteDetail,
  AdminSiteGetRequest,
  AdminSiteListItem,
  AdminSiteListRequest,
  AdminSiteUpdateRequest,
  AdminTranslationArchiveRequest,
  AdminTranslationCreateRequest,
  AdminTranslationDetail,
  AdminTranslationGetRequest,
  AdminTranslationListItem,
  AdminTranslationListRequest,
  AdminTranslationUpdateRequest,
  AdminTermsOfUseAcceptanceItem,
  AdminTotpSetup,
  AdminTwoFactorSettings,
} from "../admin/types/adminEntities";
import { AuthActionResponse, AuthStatus } from "../admin/types/admin";

const JSON_ACCEPT_HEADERS = { Accept: "application/json" } as const;
const JSON_HEADERS = { Accept: "application/json", "Content-Type": "application/json" } as const;

export const API_TRANSLATIONS_PATH = "/v/api/translations";

export const API_ADMIN_AUTH_ME_PATH = "/a/api/auth/me";
export const API_ADMIN_AUTH_SIGN_IN_PATH = "/a/api/auth/sign-in";
export const API_ADMIN_AUTH_SIGN_UP_PATH = "/a/api/auth/sign-up";
export const API_ADMIN_AUTH_FORGOT_PASSWORD_REQUEST_PATH = "/a/api/auth/forgot-password/request";
export const API_ADMIN_AUTH_FORGOT_PASSWORD_RESET_PATH = "/a/api/auth/forgot-password/reset";
export const API_ADMIN_AUTH_VERIFY_EMAIL_PATH = "/a/api/auth/verify-email";
export const API_ADMIN_AUTH_VERIFY_EMAIL_RESEND_PATH = "/a/api/auth/verify-email/resend";
export const API_ADMIN_AUTH_TWO_FACTOR_COMPLETE_PATH = "/a/api/auth/two-factor/complete";
export const API_ADMIN_AUTH_SIGN_OUT_PATH = "/a/api/auth/sign-out";
export const API_ADMIN_TERMS_OF_USE_ACCEPT_PATH = "/a/api/terms-of-use/accept";
export const API_TERMS_OF_USE_BASE = "/a/api/terms-of-use";
export const API_TERMS_OF_USE_LATEST_PATH = "/a/api/terms-of-use/latest";
export const API_TERMS_OF_USE_LATEST_SUMMARY_PATH = "/a/api/terms-of-use/latest/summary";

export const API_ADMIN_ORGANIZATIONS_LIST_PATH = "/a/api/organizations/list";
export const API_ADMIN_ORGANIZATIONS_GET_PATH = "/a/api/organizations/get";
export const API_ADMIN_ORGANIZATIONS_SUBSCRIPTION_GET_PATH = "/a/api/organizations/subscription/get";
export const API_ADMIN_ORGANIZATIONS_USAGE_GET_PATH = "/a/api/organizations/usage/get";
export const API_ADMIN_ORGANIZATIONS_SUBSCRIPTION_UPDATE_PATH = "/a/api/organizations/subscription/update";
export const API_ADMIN_ORGANIZATIONS_PERMISSIONS_PATH = "/a/api/organizations/permissions";
export const API_ADMIN_ORGANIZATIONS_CREATE_PATH = "/a/api/organizations/create";
export const API_ADMIN_ORGANIZATIONS_UPDATE_PATH = "/a/api/organizations/update";
export const API_ADMIN_ORGANIZATIONS_INTERNALS_GET_PATH = "/a/api/organizations/internals/get";
export const API_ADMIN_ORGANIZATIONS_INTERNALS_UPDATE_PATH = "/a/api/organizations/internals/update";
export const API_ADMIN_ORGANIZATIONS_ARCHIVE_PATH = "/a/api/organizations/archive";
export const API_ADMIN_ORGANIZATIONS_UNARCHIVE_PATH = "/a/api/organizations/unarchive";
export const API_ADMIN_ORGANIZATIONS_USERS_LIST_PATH = "/a/api/organizations/users/list";
export const API_ADMIN_ORGANIZATIONS_USERS_INVITE_PATH = "/a/api/organizations/invitations/invite";
export const API_ADMIN_ORGANIZATIONS_USERS_REMOVE_PATH = "/a/api/organizations/users/remove";
export const API_ADMIN_ORGANIZATIONS_USERS_CHANGE_ROLE_PATH = "/a/api/organizations/users/change-role";
export const API_ADMIN_ORGANIZATIONS_USERS_DISABLE_PATH = "/a/api/organizations/users/disable";
export const API_ADMIN_ORGANIZATIONS_INVITATIONS_CANCEL_PATH = "/a/api/organizations/invitations/cancel";
export const API_ADMIN_ORGANIZATIONS_INVITATIONS_RESEND_PATH = "/a/api/organizations/invitations/resend";
export const API_ADMIN_ORGANIZATIONS_INVITATIONS_PREVIEW_PATH = "/a/api/organizations/invitations/preview";
export const API_ADMIN_ORGANIZATIONS_INVITATIONS_ACCEPT_PATH = "/a/api/organizations/invitations/accept";
export const API_ADMIN_ORGANIZATIONS_INVITATIONS_DECLINE_PATH = "/a/api/organizations/invitations/decline";

export const API_ADMIN_DOMAINS_SETTINGS_GET_PATH = "/a/api/domains/settings/get";
export const API_ADMIN_DOMAINS_SETTINGS_UPDATE_PATH = "/a/api/domains/settings/update";
export const API_ADMIN_DOMAINS_MANAGED_LIST_PATH = "/a/api/domains/managed/list";
export const API_ADMIN_DOMAINS_MANAGED_GET_PATH = "/a/api/domains/managed/get";
export const API_ADMIN_DOMAINS_MANAGED_AVAILABILITY_PATH = "/a/api/domains/managed/availability";
export const API_ADMIN_DOMAINS_MANAGED_CREATE_PATH = "/a/api/domains/managed/create";
export const API_ADMIN_DOMAINS_MANAGED_ARCHIVE_PATH = "/a/api/domains/managed/archive";
export const API_ADMIN_DOMAINS_MANAGED_UNARCHIVE_PATH = "/a/api/domains/managed/unarchive";
export const API_ADMIN_DOMAINS_MANAGED_DELETE_PATH = "/a/api/domains/managed/delete";
export const API_ADMIN_DOMAINS_CONNECTED_LIST_PATH = "/a/api/domains/connected/list";
export const API_ADMIN_DOMAINS_CONNECTED_GET_PATH = "/a/api/domains/connected/get";
export const API_ADMIN_DOMAINS_CONNECTED_CREATE_PATH = "/a/api/domains/connected/create";
export const API_ADMIN_DOMAINS_CONNECTED_ARCHIVE_PATH = "/a/api/domains/connected/archive";
export const API_ADMIN_DOMAINS_CONNECTED_UNARCHIVE_PATH = "/a/api/domains/connected/unarchive";
export const API_ADMIN_DOMAINS_CONNECTED_DELETE_PATH = "/a/api/domains/connected/delete";
export const API_ADMIN_DOMAINS_CONNECTED_VERIFY_PATH = "/a/api/domains/connected/verify";
export const API_ADMIN_DOMAINS_CONNECTED_MARK_VERIFIED_PATH = "/a/api/domains/connected/mark-verified";

export const API_ADMIN_SITES_LIST_PATH = "/a/api/sites/list";
export const API_ADMIN_SITES_GET_PATH = "/a/api/sites/get";
export const API_ADMIN_SITES_CREATE_PATH = "/a/api/sites/create";
export const API_ADMIN_SITES_UPDATE_PATH = "/a/api/sites/update";
export const API_ADMIN_SITES_ARCHIVE_PATH = "/a/api/sites/archive";
export const API_ADMIN_SITES_UNARCHIVE_PATH = "/a/api/sites/unarchive";

export const API_ADMIN_SIGNS_LIST_PATH = "/a/api/signs/list";
export const API_ADMIN_SIGNS_GET_PATH = "/a/api/signs/get";
export const API_ADMIN_SIGNS_CREATE_PATH = "/a/api/signs/create";
export const API_ADMIN_SIGNS_UPDATE_PATH = "/a/api/signs/update";
export const API_ADMIN_SIGNS_ARCHIVE_PATH = "/a/api/signs/archive";
export const API_ADMIN_SIGNS_UNARCHIVE_PATH = "/a/api/signs/unarchive";

export const API_ADMIN_TRANSLATIONS_LIST_PATH = "/a/api/translations/list";
export const API_ADMIN_TRANSLATIONS_GET_PATH = "/a/api/translations/get";
export const API_ADMIN_TRANSLATIONS_CREATE_PATH = "/a/api/translations/create";
export const API_ADMIN_TRANSLATIONS_UPDATE_PATH = "/a/api/translations/update";
export const API_ADMIN_TRANSLATIONS_ARCHIVE_PATH = "/a/api/translations/archive";
export const API_ADMIN_TRANSLATIONS_UNARCHIVE_PATH = "/a/api/translations/unarchive";

export const API_ADMIN_PROFILE_GET_PATH = "/a/api/profile/get";
export const API_ADMIN_PROFILE_UPDATE_PATH = "/a/api/profile/update";
export const API_ADMIN_SYSTEM_INFORMATION_GET_PATH = "/a/api/administration/system-info/get";
export const API_ADMIN_TERMS_OF_USE_ACCEPTANCES_LIST_PATH = "/a/api/terms-of-use/acceptances/list";
export const API_ADMIN_TWO_FACTOR_SETTINGS_PATH = "/a/api/two-factor/settings";
export const API_ADMIN_TWO_FACTOR_EMAIL_ENABLE_PATH = "/a/api/two-factor/email/enable";
export const API_ADMIN_TWO_FACTOR_TOTP_SETUP_PATH = "/a/api/two-factor/totp/setup";
export const API_ADMIN_TWO_FACTOR_TOTP_CONFIRM_PATH = "/a/api/two-factor/totp/confirm";
export const API_ADMIN_TWO_FACTOR_DISABLE_PATH = "/a/api/two-factor/disable";
export const API_ADMIN_TWO_FACTOR_INVALIDATE_OTHER_SESSIONS_PATH = "/a/api/two-factor/sessions/invalidate-others";
export const API_ADMIN_TWO_FACTOR_SESSIONS_LIST_PATH = "/a/api/two-factor/sessions/list";
export const API_ADMIN_TWO_FACTOR_SESSION_INVALIDATE_PATH = "/a/api/two-factor/sessions/invalidate";

type RequestErrorNotification = {
  correlationId?: string;
  errorCode?: string;
  message?: string;
};

type RequestErrorNotifier = (notification?: RequestErrorNotification | string) => void;
type UnauthorizedResponseHandler = () => void;

type JsonRequestBody = BodyInit | null | object;

type RequestOptions = {
  body?: JsonRequestBody;
  errorNotificationMessage?: string;
  handledStatuses?: number[];
  handleUnauthorized?: boolean;
  notifyOnError?: boolean;
} & Omit<RequestInit, "body" | "credentials">;

type SignInRequest = {
  email: string;
  password: string;
};

type SignUpRequest = {
  acceptedTerms: boolean;
  email: string;
  emailLanguage: string;
  name: string;
  password: string;
  receiveProductUpdates: boolean;
  termsOfUseUuid: null | string;
  turnstileToken: null | string;
};

type AcceptTermsOfUseRequest = {
  uuid: string;
};

type ForgotPasswordRequest = {
  email: string;
  turnstileToken: null | string;
};

type ResetPasswordRequest = {
  newPassword: string;
  token: string;
};

type VerifyEmailRequest = {
  token: string;
};

type TwoFactorRequest = {
  code: string;
};

type VerifyEmailResendRequest = {
  email: string;
  turnstileToken: null | string;
};

type OrganizationInvitationTokenRequest = {
  token: string;
};

type OrganizationInvitationStatus =
  | "ACCEPTED"
  | "ACTIVE"
  | "CANCELLED"
  | "DECLINED"
  | "EXPIRED"
  | "INVALID";

export type OrganizationInvitationPreviewResponse = {
  organizationName: null | string;
  belongsToCurrentUser: boolean;
  status: OrganizationInvitationStatus;
};

type ConfirmTotpRequest = {
  code: string;
};

type InvalidateSessionRequest = {
  revocationHandle: string;
};

type DisableAdminUserRequest = {
  email: string;
};

export type RequestResult<T> = {
  payload: T;
  response: Response;
};

export type TermsOfUseResponse = {
  content: string;
  effectiveFrom: string;
  latest: boolean;
  latestUuid: string;
  uuid: string;
};

export type TermsOfUseSummaryResponse = {
  effectiveFrom: string;
};

export type GenericResponse = {
  correlationId?: null | string;
  errorCode?: null | string;
  success: boolean;
};

export type AdminDomainMutationResponse = {
  errorCode: null | string;
  success: boolean;
};

export type AdminCreatedResponse = {
  errorCode: null | string;
  id: string;
  success: boolean;
};

export class HttpRequestError extends Error {
  payload: unknown;
  status: number;

  constructor(message: string, status: number, payload: unknown) {
    super(message);
    this.name = "HttpRequestError";
    this.payload = payload;
    this.status = status;
  }
}

let requestErrorNotifier: null | RequestErrorNotifier = null;
let unauthorizedResponseHandler: null | UnauthorizedResponseHandler = null;

const isJsonBody = (body: JsonRequestBody | undefined): body is object => {
  if (body === null || typeof body !== "object") {
    return false;
  }
  return !(body instanceof Blob || body instanceof FormData || body instanceof URLSearchParams || body instanceof ArrayBuffer);
};

const resolveErrorMessage = (payload: unknown, response: Response) => {
  if (payload && typeof payload === "object" && "errorCode" in payload) {
    return "";
  }
  return `Request failed with status ${response.status}`;
};

const parseResponsePayload = async (response: Response): Promise<unknown> => {
  if (response.status === 204) {
    return null;
  }

  const contentType = response.headers.get("content-type") ?? "";
  if (contentType.includes("application/json")) {
    try {
      return await response.json();
    } catch {
      return null;
    }
  }

  try {
    return await response.text();
  } catch {
    return null;
  }
};

const notifyRequestError = (message?: string) => {
  requestErrorNotifier?.(message ? { message } : undefined);
};

export const extractCorrelationId = (payload: unknown) => {
  if (payload && typeof payload === "object" && "correlationId" in payload) {
    const correlationId = payload.correlationId;
    if (typeof correlationId === "string" && correlationId.trim().length > 0) {
      return correlationId;
    }
  }
  return null;
};

const extractErrorCode = (payload: unknown) => {
  if (payload && typeof payload === "object" && "errorCode" in payload) {
    const errorCode = payload.errorCode;
    if (typeof errorCode === "string" && errorCode.trim().length > 0) {
      return errorCode;
    }
  }
  return null;
};

export const registerRequestErrorNotifier = (notifier: null | RequestErrorNotifier) => {
  requestErrorNotifier = notifier;
};

export const registerUnauthorizedResponseHandler = (handler: null | UnauthorizedResponseHandler) => {
  unauthorizedResponseHandler = handler;
};

export const extractRequestErrorCode = (error: unknown) => {
  if (error && typeof error === "object" && "payload" in error) {
    return extractErrorCode(error.payload);
  }
  return null;
};

export const buildTranslationRequestPath = (uuid: string) => `${API_TRANSLATIONS_PATH}/${uuid}`;

export const requestJson = async <T>(path: string, options: RequestOptions = {}): Promise<RequestResult<T>> => {
  const {
    body,
    errorNotificationMessage,
    handledStatuses = [],
    handleUnauthorized = true,
    headers,
    notifyOnError = true,
    ...init
  } = options;

  const requestHeaders = new Headers(headers ?? {});
  if (!requestHeaders.has("Accept")) {
    requestHeaders.set("Accept", "application/json");
  }

  let requestBody: BodyInit | null | undefined = body;
  if (isJsonBody(body)) {
    requestBody = JSON.stringify(body);
    if (!requestHeaders.has("Content-Type")) {
      requestHeaders.set("Content-Type", "application/json");
    }
  }

  let response: Response;
  try {
    response = await fetch(path, {
      ...init,
      body: requestBody,
      credentials: "same-origin",
      headers: requestHeaders,
    });
  } catch (error) {
    if (notifyOnError) {
      notifyRequestError(errorNotificationMessage);
    }
    throw error;
  }

  const payload = (await parseResponsePayload(response)) as T;
  if (handleUnauthorized && response.status === 401) {
    unauthorizedResponseHandler?.();
  }

  if (!response.ok && !handledStatuses.includes(response.status)) {
    if (notifyOnError) {
      const errorCode = extractErrorCode(payload);
      const correlationId = extractCorrelationId(payload);
      if (errorNotificationMessage) {
        notifyRequestError(errorNotificationMessage);
      } else if (errorCode) {
        requestErrorNotifier?.({ correlationId: correlationId ?? undefined, errorCode });
      } else {
        requestErrorNotifier?.({ correlationId: correlationId ?? undefined });
      }
    }
    throw new HttpRequestError(resolveErrorMessage(payload, response), response.status, payload);
  }

  return { payload, response };
};

export const fetchViewTranslation = <T>(
  uuid: string,
  language: string,
  options: Pick<RequestOptions, "errorNotificationMessage" | "notifyOnError" | "signal"> = {},
) => {
  const headers = new Headers(JSON_ACCEPT_HEADERS);
  if (language.trim().length > 0) {
    headers.set("X-Content-Language", language.trim());
  }
  return requestJson<T>(buildTranslationRequestPath(uuid), { ...options, headers });
};

export const requestText = (path: string, options: RequestOptions = {}) => {
  return requestJson<string>(path, options);
};

export const fetchLatestTermsOfUse = () => {
  return requestJson<TermsOfUseResponse>(API_TERMS_OF_USE_LATEST_PATH, {
    handleUnauthorized: false,
    headers: JSON_ACCEPT_HEADERS
  });
};

export const fetchLatestTermsOfUseForLanguage = (language: string) => {
  const headers = new Headers(JSON_ACCEPT_HEADERS);
  if (language.trim().length > 0) {
    headers.set("X-Content-Language", language.trim());
  }
  return requestJson<TermsOfUseResponse>(API_TERMS_OF_USE_LATEST_PATH, {
    handleUnauthorized: false,
    headers
  });
};

export const fetchTermsOfUseByUuidForLanguage = (uuid: string, language: string) => {
  const headers = new Headers(JSON_ACCEPT_HEADERS);
  if (language.trim().length > 0) {
    headers.set("X-Content-Language", language.trim());
  }
  return requestJson<TermsOfUseResponse>(`${API_TERMS_OF_USE_BASE}/${uuid}`, {
    handleUnauthorized: false,
    headers
  });
};

export const fetchLatestTermsOfUseSummary = () => {
  return requestJson<TermsOfUseSummaryResponse>(API_TERMS_OF_USE_LATEST_SUMMARY_PATH, {
    handleUnauthorized: false,
    headers: JSON_ACCEPT_HEADERS
  });
};

export const fetchAdminAuthStatus = () => {
  return requestJson<AuthStatus>(API_ADMIN_AUTH_ME_PATH, {
    handledStatuses: [401, 403],
    handleUnauthorized: false,
    headers: JSON_ACCEPT_HEADERS
  });
};

export const signInAdmin = (body: SignInRequest) => {
  return requestJson<AuthStatus>(API_ADMIN_AUTH_SIGN_IN_PATH, {
    body,
    handledStatuses: [401, 403],
    handleUnauthorized: false,
    headers: JSON_HEADERS,
    method: "POST",
  });
};

export const signUpAdmin = (body: SignUpRequest) => {
  return requestJson<AuthStatus>(API_ADMIN_AUTH_SIGN_UP_PATH, {
    body,
    handledStatuses: [201, 400, 409],
    handleUnauthorized: false,
    headers: JSON_HEADERS,
    method: "POST",
  });
};

export const requestAdminPasswordReset = (body: ForgotPasswordRequest) => {
  return requestJson<AuthActionResponse>(API_ADMIN_AUTH_FORGOT_PASSWORD_REQUEST_PATH, {
    body,
    handledStatuses: [400, 403],
    handleUnauthorized: false,
    headers: JSON_HEADERS,
    method: "POST",
  });
};

export const resetAdminPassword = (body: ResetPasswordRequest) => {
  return requestJson<AuthActionResponse>(API_ADMIN_AUTH_FORGOT_PASSWORD_RESET_PATH, {
    body,
    handledStatuses: [400, 403],
    handleUnauthorized: false,
    headers: JSON_HEADERS,
    method: "POST",
  });
};

export const verifyAdminEmail = (body: VerifyEmailRequest) => {
  return requestJson<AuthActionResponse>(API_ADMIN_AUTH_VERIFY_EMAIL_PATH, {
    body,
    handledStatuses: [400],
    handleUnauthorized: false,
    headers: JSON_HEADERS,
    method: "POST",
  });
};

export const completeAdminTwoFactor = (body: TwoFactorRequest) => {
  return requestJson<AuthStatus>(API_ADMIN_AUTH_TWO_FACTOR_COMPLETE_PATH, {
    body,
    handledStatuses: [401],
    handleUnauthorized: false,
    headers: JSON_HEADERS,
    method: "POST",
  });
};

export const resendAdminVerification = (body: VerifyEmailResendRequest) => {
  return requestJson<AuthActionResponse>(API_ADMIN_AUTH_VERIFY_EMAIL_RESEND_PATH, {
    body,
    handledStatuses: [400],
    handleUnauthorized: false,
    headers: JSON_HEADERS,
    method: "POST",
  });
};

export const signOutAdmin = () => {
  return requestJson<null>(API_ADMIN_AUTH_SIGN_OUT_PATH, {
    handledStatuses: [401, 403],
    handleUnauthorized: false,
    headers: JSON_ACCEPT_HEADERS,
    method: "POST",
  });
};

export const acceptLatestTermsOfUse = (body: AcceptTermsOfUseRequest) => {
  return requestJson<GenericResponse>(API_ADMIN_TERMS_OF_USE_ACCEPT_PATH, {
    body,
    handledStatuses: [400, 401, 404],
    headers: JSON_HEADERS,
    method: "POST",
  });
};

export const previewAdminOrganizationInvitation = (body: OrganizationInvitationTokenRequest) => {
  return requestJson<OrganizationInvitationPreviewResponse>(API_ADMIN_ORGANIZATIONS_INVITATIONS_PREVIEW_PATH, {
    body,
    handledStatuses: [400],
    headers: JSON_HEADERS,
    method: "POST",
  });
};

export const acceptAdminOrganizationInvitation = (body: OrganizationInvitationTokenRequest) => {
  return requestJson<GenericResponse>(API_ADMIN_ORGANIZATIONS_INVITATIONS_ACCEPT_PATH, {
    body,
    handledStatuses: [400],
    headers: JSON_HEADERS,
    method: "POST",
  });
};

export const declineAdminOrganizationInvitation = (body: OrganizationInvitationTokenRequest) => {
  return requestJson<GenericResponse>(API_ADMIN_ORGANIZATIONS_INVITATIONS_DECLINE_PATH, {
    body,
    handledStatuses: [400],
    headers: JSON_HEADERS,
    method: "POST",
  });
};

export const listAdminOrganizations = (body: AdminOrganizationListRequest) => {
  return requestJson<AdminPage<AdminOrganizationListItem>>(API_ADMIN_ORGANIZATIONS_LIST_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const listAdminOrganizationUsers = (body: AdminOrganizationUsersListRequest) => {
  return requestJson<AdminPage<AdminOrganizationUserItem>>(API_ADMIN_ORGANIZATIONS_USERS_LIST_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const listAdminSites = (body: AdminSiteListRequest) => {
  return requestJson<AdminPage<AdminSiteListItem>>(API_ADMIN_SITES_LIST_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const listAdminSigns = (body: AdminSignListRequest) => {
  return requestJson<AdminPage<AdminSignListItem>>(API_ADMIN_SIGNS_LIST_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const listAdminTranslations = (body: AdminTranslationListRequest) => {
  return requestJson<AdminPage<AdminTranslationListItem>>(API_ADMIN_TRANSLATIONS_LIST_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const getAdminOrganization = (body: AdminOrganizationGetRequest) => {
  return requestJson<AdminOrganizationDetail>(API_ADMIN_ORGANIZATIONS_GET_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const getAdminOrganizationInternals = (body: AdminOrganizationInternalsGetRequest) => {
  return requestJson<AdminOrganizationInternalsDetail>(API_ADMIN_ORGANIZATIONS_INTERNALS_GET_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const getAdminOrganizationSubscription = (body: AdminOrganizationSubscriptionGetRequest) => {
  return requestJson<AdminOrganizationSubscriptionDetail>(API_ADMIN_ORGANIZATIONS_SUBSCRIPTION_GET_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const getAdminOrganizationDomainSettings = (body: AdminOrganizationDomainSettingsGetRequest) => {
  return requestJson<AdminOrganizationDomainSettingsDetail>(API_ADMIN_DOMAINS_SETTINGS_GET_PATH, {
    body,
    handledStatuses: [404],
    headers: JSON_HEADERS,
    method: "POST"
  });
};

export const getAdminOrganizationUsage = (body: AdminOrganizationSubscriptionGetRequest) => {
  return requestJson<AdminOrganizationUsageDetail>(API_ADMIN_ORGANIZATIONS_USAGE_GET_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const updateAdminOrganizationSubscription = (body: AdminOrganizationSubscriptionUpdateRequest) => {
  return requestJson<AdminMutationResponse>(API_ADMIN_ORGANIZATIONS_SUBSCRIPTION_UPDATE_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const updateAdminOrganizationDomainSettings = (body: AdminOrganizationDomainSettingsUpdateRequest) => {
  return requestJson<AdminDomainMutationResponse>(API_ADMIN_DOMAINS_SETTINGS_UPDATE_PATH, {
    body,
    handledStatuses: [404],
    headers: JSON_HEADERS,
    method: "POST"
  });
};

export const getAdminOrganizationPermissions = (body: AdminOrganizationGetRequest) => {
  return requestJson<AdminOrganizationPermissions>(API_ADMIN_ORGANIZATIONS_PERMISSIONS_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const listAdminManagedDomains = (body: AdminManagedDomainsListRequest) => {
  return requestJson<AdminManagedDomainDetail[]>(API_ADMIN_DOMAINS_MANAGED_LIST_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const getAdminManagedDomain = (body: AdminManagedDomainGetRequest) => {
  return requestJson<AdminManagedDomainDetail>(API_ADMIN_DOMAINS_MANAGED_GET_PATH, {
    body,
    handledStatuses: [404],
    headers: JSON_HEADERS,
    method: "POST"
  });
};

export const checkAdminManagedDomainAvailability = (body: AdminManagedDomainAvailabilityRequest) => {
  return requestJson<AdminManagedDomainAvailabilityDetail>(API_ADMIN_DOMAINS_MANAGED_AVAILABILITY_PATH, {
    body,
    headers: JSON_HEADERS,
    method: "POST"
  });
};

export const createAdminManagedDomain = (body: AdminManagedDomainCreateRequest) => {
  return requestJson<AdminCreatedResponse>(API_ADMIN_DOMAINS_MANAGED_CREATE_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const archiveAdminManagedDomain = (body: AdminManagedDomainArchiveRequest) => {
  return requestJson<AdminDomainMutationResponse>(API_ADMIN_DOMAINS_MANAGED_ARCHIVE_PATH, {
    body,
    handledStatuses: [404],
    headers: JSON_HEADERS,
    method: "POST"
  });
};

export const unarchiveAdminManagedDomain = (body: AdminManagedDomainArchiveRequest) => {
  return requestJson<AdminDomainMutationResponse>(API_ADMIN_DOMAINS_MANAGED_UNARCHIVE_PATH, {
    body,
    handledStatuses: [404],
    headers: JSON_HEADERS,
    method: "POST"
  });
};

export const deleteAdminManagedDomain = (body: AdminManagedDomainArchiveRequest) => {
  return requestJson<AdminDomainMutationResponse>(API_ADMIN_DOMAINS_MANAGED_DELETE_PATH, {
    body,
    handledStatuses: [404],
    headers: JSON_HEADERS,
    method: "POST"
  });
};

export const listAdminConnectedDomains = (body: AdminConnectedDomainsListRequest) => {
  return requestJson<AdminConnectedDomainDetail[]>(API_ADMIN_DOMAINS_CONNECTED_LIST_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const getAdminConnectedDomain = (body: AdminConnectedDomainGetRequest) => {
  return requestJson<AdminConnectedDomainDetail>(API_ADMIN_DOMAINS_CONNECTED_GET_PATH, {
    body,
    handledStatuses: [404],
    headers: JSON_HEADERS,
    method: "POST"
  });
};

export const createAdminConnectedDomain = (body: AdminConnectedDomainCreateRequest) => {
  return requestJson<AdminCreatedResponse>(API_ADMIN_DOMAINS_CONNECTED_CREATE_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const archiveAdminConnectedDomain = (body: AdminConnectedDomainArchiveRequest) => {
  return requestJson<AdminDomainMutationResponse>(API_ADMIN_DOMAINS_CONNECTED_ARCHIVE_PATH, {
    body,
    handledStatuses: [404],
    headers: JSON_HEADERS,
    method: "POST"
  });
};

export const unarchiveAdminConnectedDomain = (body: AdminConnectedDomainArchiveRequest) => {
  return requestJson<AdminDomainMutationResponse>(API_ADMIN_DOMAINS_CONNECTED_UNARCHIVE_PATH, {
    body,
    handledStatuses: [404],
    headers: JSON_HEADERS,
    method: "POST"
  });
};

export const deleteAdminConnectedDomain = (body: AdminConnectedDomainArchiveRequest) => {
  return requestJson<AdminDomainMutationResponse>(API_ADMIN_DOMAINS_CONNECTED_DELETE_PATH, {
    body,
    handledStatuses: [404],
    headers: JSON_HEADERS,
    method: "POST"
  });
};

export const verifyAdminConnectedDomain = (body: AdminConnectedDomainVerifyRequest) => {
  return requestJson<AdminConnectedDomainVerificationDetail>(API_ADMIN_DOMAINS_CONNECTED_VERIFY_PATH, {
    body,
    handledStatuses: [404],
    headers: JSON_HEADERS,
    method: "POST"
  });
};

export const markAdminConnectedDomainVerified = (body: AdminConnectedDomainMarkVerifiedRequest) => {
  return requestJson<AdminDomainMutationResponse>(API_ADMIN_DOMAINS_CONNECTED_MARK_VERIFIED_PATH, {
    body,
    handledStatuses: [404],
    headers: JSON_HEADERS,
    method: "POST"
  });
};

export const getAdminSite = (body: AdminSiteGetRequest) => {
  return requestJson<AdminSiteDetail>(API_ADMIN_SITES_GET_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const getAdminSign = (body: AdminSignGetRequest) => {
  return requestJson<AdminSignDetail>(API_ADMIN_SIGNS_GET_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const getAdminTranslation = (body: AdminTranslationGetRequest) => {
  return requestJson<AdminTranslationDetail>(API_ADMIN_TRANSLATIONS_GET_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const createAdminOrganization = (body: AdminOrganizationCreateRequest) => {
  return requestJson<AdminCreatedResponse>(API_ADMIN_ORGANIZATIONS_CREATE_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const createAdminSite = (body: AdminSiteCreateRequest) => {
  return requestJson<AdminCreatedResponse>(API_ADMIN_SITES_CREATE_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const createAdminSign = (body: AdminSignCreateRequest) => {
  return requestJson<AdminCreatedResponse>(API_ADMIN_SIGNS_CREATE_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const createAdminTranslation = (body: AdminTranslationCreateRequest) => {
  return requestJson<AdminCreatedResponse>(API_ADMIN_TRANSLATIONS_CREATE_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const updateAdminOrganization = (body: AdminOrganizationUpdateRequest) => {
  return requestJson<AdminMutationResponse>(API_ADMIN_ORGANIZATIONS_UPDATE_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const updateAdminOrganizationInternals = (body: AdminOrganizationInternalsUpdateRequest) => {
  return requestJson<AdminMutationResponse>(API_ADMIN_ORGANIZATIONS_INTERNALS_UPDATE_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const inviteAdminOrganizationUser = (body: AdminOrganizationInviteUserRequest) => {
  return requestJson<AdminMutationResponse>(API_ADMIN_ORGANIZATIONS_USERS_INVITE_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const removeAdminOrganizationUser = (body: AdminOrganizationRemoveUserRequest) => {
  return requestJson<AdminMutationResponse>(API_ADMIN_ORGANIZATIONS_USERS_REMOVE_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const updateAdminOrganizationUserRole = (body: AdminOrganizationUpdateUserRoleRequest) => {
  return requestJson<AdminMutationResponse>(API_ADMIN_ORGANIZATIONS_USERS_CHANGE_ROLE_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const cancelAdminOrganizationInvitation = (body: AdminOrganizationCancelInvitationRequest) => {
  return requestJson<AdminMutationResponse>(API_ADMIN_ORGANIZATIONS_INVITATIONS_CANCEL_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const resendAdminOrganizationInvitation = (body: AdminOrganizationResendInvitationRequest) => {
  return requestJson<AdminMutationResponse>(API_ADMIN_ORGANIZATIONS_INVITATIONS_RESEND_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const updateAdminSite = (body: AdminSiteUpdateRequest) => {
  return requestJson<AdminMutationResponse>(API_ADMIN_SITES_UPDATE_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const updateAdminSign = (body: AdminSignUpdateRequest) => {
  return requestJson<AdminMutationResponse>(API_ADMIN_SIGNS_UPDATE_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const updateAdminTranslation = (body: AdminTranslationUpdateRequest) => {
  return requestJson<AdminMutationResponse>(API_ADMIN_TRANSLATIONS_UPDATE_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const archiveAdminOrganization = (body: AdminOrganizationArchiveRequest) => {
  return requestJson<AdminMutationResponse>(API_ADMIN_ORGANIZATIONS_ARCHIVE_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const archiveAdminSite = (body: AdminSiteArchiveRequest) => {
  return requestJson<AdminMutationResponse>(API_ADMIN_SITES_ARCHIVE_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const archiveAdminSign = (body: AdminSignArchiveRequest) => {
  return requestJson<AdminMutationResponse>(API_ADMIN_SIGNS_ARCHIVE_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const archiveAdminTranslation = (body: AdminTranslationArchiveRequest) => {
  return requestJson<AdminMutationResponse>(API_ADMIN_TRANSLATIONS_ARCHIVE_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const unarchiveAdminOrganization = (body: AdminOrganizationArchiveRequest) => {
  return requestJson<AdminMutationResponse>(API_ADMIN_ORGANIZATIONS_UNARCHIVE_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const unarchiveAdminSite = (body: AdminSiteArchiveRequest) => {
  return requestJson<AdminMutationResponse>(API_ADMIN_SITES_UNARCHIVE_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const unarchiveAdminSign = (body: AdminSignArchiveRequest) => {
  return requestJson<AdminMutationResponse>(API_ADMIN_SIGNS_UNARCHIVE_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const unarchiveAdminTranslation = (body: AdminTranslationArchiveRequest) => {
  return requestJson<AdminMutationResponse>(API_ADMIN_TRANSLATIONS_UNARCHIVE_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const getAdminProfile = () => {
  return requestJson<AdminProfileDetail>(API_ADMIN_PROFILE_GET_PATH, { body: {}, headers: JSON_HEADERS, method: "POST" });
};

export const getAdminSystemInformation = () => {
  return requestJson<AdminSystemInformationDetail>(API_ADMIN_SYSTEM_INFORMATION_GET_PATH, { body: {}, headers: JSON_HEADERS, method: "POST" });
};

export const updateAdminProfile = (body: AdminProfileUpdateRequest) => {
  return requestJson<AdminMutationResponse>(API_ADMIN_PROFILE_UPDATE_PATH, { body, headers: JSON_HEADERS, method: "POST" });
};

export const listAdminTermsOfUseAcceptances = () => {
  return requestJson<AdminTermsOfUseAcceptanceItem[]>(API_ADMIN_TERMS_OF_USE_ACCEPTANCES_LIST_PATH, {
    body: {},
    headers: JSON_HEADERS,
    method: "POST"
  });
};

export const getAdminTwoFactorSettings = () => {
  return requestJson<AdminTwoFactorSettings>(API_ADMIN_TWO_FACTOR_SETTINGS_PATH, { body: {}, headers: JSON_HEADERS, method: "POST" });
};

export const enableAdminEmailTwoFactor = () => {
  return requestJson<AdminMutationResponse>(API_ADMIN_TWO_FACTOR_EMAIL_ENABLE_PATH, { body: {}, headers: JSON_HEADERS, method: "POST" });
};

export const setupAdminTotpTwoFactor = () => {
  return requestJson<AdminTotpSetup>(API_ADMIN_TWO_FACTOR_TOTP_SETUP_PATH, { body: {}, headers: JSON_HEADERS, method: "POST" });
};

export const confirmAdminTotpTwoFactor = (body: ConfirmTotpRequest) => {
  return requestJson<AdminMutationResponse>(API_ADMIN_TWO_FACTOR_TOTP_CONFIRM_PATH, {
    body,
    handledStatuses: [400],
    headers: JSON_HEADERS,
    method: "POST"
  });
};

export const disableAdminTwoFactor = () => {
  return requestJson<AdminMutationResponse>(API_ADMIN_TWO_FACTOR_DISABLE_PATH, { body: {}, headers: JSON_HEADERS, method: "POST" });
};

export const invalidateOtherAdminSessions = () => {
  return requestJson<AdminMutationResponse>(API_ADMIN_TWO_FACTOR_INVALIDATE_OTHER_SESSIONS_PATH, { body: {}, headers: JSON_HEADERS, method: "POST" });
};

export const listAdminActiveSessions = () => {
  return requestJson<AdminActiveSession[]>(API_ADMIN_TWO_FACTOR_SESSIONS_LIST_PATH, { body: {}, headers: JSON_HEADERS, method: "POST" });
};

export const invalidateAdminSession = (body: InvalidateSessionRequest) => {
  return requestJson<AdminMutationResponse>(API_ADMIN_TWO_FACTOR_SESSION_INVALIDATE_PATH, {
    body,
    handledStatuses: [404],
    headers: JSON_HEADERS,
    method: "POST"
  });
};

export const disableAdminUser = (body: DisableAdminUserRequest) => {
  return requestJson<AdminMutationResponse>(API_ADMIN_ORGANIZATIONS_USERS_DISABLE_PATH, {
    body,
    headers: JSON_HEADERS,
    method: "POST"
  });
};
